import { useQuery } from '@tanstack/react-query'

import { getAllProductPhotos } from '@flecto/api/store'
import { type ParameterID } from '@flecto/types'

export type UseQueryGetAllProductPhotosOptions = {
  storeDomain: string
  itemId: ParameterID
}

export function useQueryGetAllProductPhotos({
  storeDomain,
  itemId,
}: UseQueryGetAllProductPhotosOptions) {
  return useQuery({
    queryKey: ['QueryGetAllProductPhotos'],
    queryFn: async () => await getAllProductPhotos(storeDomain, itemId),
    refetchOnWindowFocus: false,
  })
}
